module.exports = __webpack_public_path__ + "img/slide-3.532ce3b8.jpg";